// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"255":"1de8f775","293":"c51435d7","386":"c645b2cd","387":"6f634755","497":"0d372f17","887":"5d843876","928":"7bc01adb"}[chunkId] + ".css";
};